// Keep the calendar date supplied by the API, including for offset timestamps.
export function expenseCalendarDate(value) {
    const match = typeof value === 'string' ? value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/) : null;
    if (!match)
        return '';
    const [year, month, day] = match.slice(1).map(Number);
    const date = new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day)
        return '';
    return `${match[1]}-${match[2]}-${match[3]}`;
}
export function groupExpensesByDay(rows, getDate) {
    const days = new Map();
    for (const row of rows) {
        const date = expenseCalendarDate(getDate(row));
        const group = days.get(date);
        if (group)
            group.push(row);
        else
            days.set(date, [row]);
    }
    const formatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    return [...days.entries()]
        .sort(([left], [right]) => left === right ? 0 : !left ? 1 : !right ? -1 : left.localeCompare(right))
        .map(([date, expenses]) => ({
        key: date || 'undated',
        label: date ? formatter.format(new Date(`${date}T00:00:00Z`)) : 'Без даты',
        rows: expenses,
    }));
}
